import React, { Component } from 'react';
import ReactTable from 'react-table';
import {withRouter, Redirect} from 'react-router-dom';
import 'react-table/react-table.css';
import axios from 'axios'
import { Modal, Button} from 'react-bootstrap';
import { requestConstants } from '../../constants';

const https = require('https');


class scenarioList extends Component {
  static propTypes = {
  };
  state = {
    scenarios_list: [],
    submitted: false,
    show_new_project_modal: false,
    new_project_name:"",
    new_request_name_trigger: null,
    selected_row: null,
    loading: true
  };

  columns = [
  {
    Header: 'Project Name',
    accessor: "request_name",
  },
  {
    Header: 'Last updated by',
    accessor: "last_updated_by"
  },
  {
    Header: 'Last modification time',
    id: 'updatedcol',
    //accessor: "updated_time",
    accessor: d => {
        return new Date(d.updated_time).toISOString();
      }
  },

  {
    Header: 'Status',
    accessor: "status"
  }
  ];


  updateState() {
    const agent = new https.Agent({  
      //rejectUnauthorized: false
    });
    let URL = `${this.props.SERVER_URLS.api}/list/${localStorage.getItem("user_id")}`
    axios.get(URL, {httpsAgent: agent} )
    .then(response => {
      if(response.data) { //has previous request
        this.setState({scenarios_list: response.data.reverse(), loading: false})
      }
    }
      )
    .catch(
      function(error) {
        console.log(
        error
      )
    })
  }

  componentDidMount() {
    this.updateState()
  }

  handleRowProps = (state, rowInfo) => ({
    onClick: () => {
        this.setState({selected_row:rowInfo})
    },
    style: {
      color: (rowInfo && rowInfo.row.type === 'warning') ? 'red' : 'black',
      cursor: (rowInfo) ? 'pointer' : 'auto',
    },
  })

  render() {
    if (this.state.new_request_name_trigger){
        return(<Redirect
            to={{
              pathname: "/ru/bw",
              //search: "?utm=your+face",
              state: { requestID: this.state.new_request_name_trigger,
                request_state: 1, 
                page_states: {}  }
            }}
          />)
    } else if (this.state.selected_row){
        if (this.state.selected_row.original.status !== requestConstants.status.IN_PROGRESS) {
            return (
                <Redirect
                    to={{
                      pathname: `/ru/details/${this.state.selected_row.original._id}`
                    }}
                />
            );
        }
        return(<Redirect
            to={{
              pathname: "/ru/bw",
              //search: "?utm=your+face",
              state: { requestID: this.state.selected_row.original._id,
                request_state: this.state.selected_row.original.request_state, 
                page_states: this.state.selected_row.original.pageStates }
            }}
          />)
    }
    return (
      <center>
        <div className="row">
          <div className="col-md">
            <div className="bp3-card bp3-elevation-2">
              <div style={{ height: '100%', width: '90%', margin: '10px', paddingBottom: "25px" }}>
                <ReactTable
                  className="-striped -highlight"
                  data={this.state.scenarios_list}
                  columns={this.columns}
                  defaultPageSize={10}
                  getTrProps={this.handleRowProps}
                  loading={this.state.loading}
                />

                <div className="button-row">
                  <button type="button" className="btn btn-primary" onClick={()=>{
                      this.setState({show_new_project_modal: true})
                    }}>Create a New LAL Application</button>
                </div>
              </div>
            </div>
          </div>
          
        </div>
        <br />

        <Modal show={this.state.show_new_project_modal} onHide={()=>{this.setState({show_new_project_modal: false})}} dialogClassName="modal-90w">
        <Modal.Header closeButton>
                <Modal.Title>Enter a name for the new Application</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <input type="text" value={this.state.new_project_name} onChange={(e)=>{this.setState({new_project_name:e.target.value})}} />
        </Modal.Body>   
                <Modal.Footer>
                <Button variant="secondary" onClick={()=>{
                    this.setState({show_new_project_modal: false})

                    }}>
                    Cancel
                    </Button>
                    <Button variant="primary" onClick={()=>{
                        if (this.state.new_project_name.length===0){
                            return
                        }
                        let URL = `${this.props.SERVER_URLS.api}/request`
                        let data = {payload:{request_name: this.state.new_project_name}}
                        const config = { headers: { 'content-type': 'application/json' } }
                        data["user_id"] = localStorage.getItem("user_id")
                        data["request_state"] = 1
                        data["status"] = "In Progress"
                        data["updated_time"] = Date.now()
                        axios.post(URL, data, config)
                          .then(response =>{
                            if (response.data.error){
                              console.log(response.data.message)
                            }
                            else {
                              this.setState({new_request_name_trigger: response.data["request_id"]})
                              /*this.props.history.push({
                                pathname: "/bw",
                                state:{"requestID":response.data["request_id"]}
                              })*/
                            }
                            })
                          .catch(
                            function(error) {
                              console.log(
                              error
                            )
                          })
                    }}>
                    Continue
                    </Button>
            </Modal.Footer>
            </Modal>
      </center>
    );
  }
}

export default withRouter(scenarioList);
